// types
import { TextareaProps } from './types';

// styles
import './textarea.css';

export default function Textarea({
  title,
  onChange,
  name,
  className = '',
  disabled,
  placeholder,
  value,
  error,
  labelClassName = '',
  borderClassName = '',
  maxLength,
  onBlur,
  rows = 7,
  tabIndex,
}: TextareaProps): React.JSX.Element {
  const setValue = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <label
      htmlFor={`textarea-${name}`}
      className={`textarea-label ${labelClassName}`}
      tabIndex={-1}
    >
      {title && <div className="textarea-title">{title}</div>}
      <span className={`textarea-wrapper ${disabled ? 'disabled' : ''}`}>
        <textarea
          name={name}
          placeholder={placeholder}
          className={`textarea ${className || ''} ${error ? 'error' : ''}`}
          id={`textarea-${name}`}
          rows={rows}
          onChange={setValue}
          onBlur={onBlur}
          value={value ?? ''}
          maxLength={maxLength}
          disabled={disabled}
          autoComplete="off"
          tabIndex={tabIndex}
        />
        <span className={`textarea-border ${borderClassName}`} />
      </span>
      {error && <div className="error-message">{error}</div>}
    </label>
  );
}
